// Relative time helpers.

export function relativeTime(iso) {
    if (!iso) return "";
    const now = new Date();
    const then = new Date(iso);
    const diffMs = now.getTime() - then.getTime();
    const sec = Math.max(1, Math.floor(diffMs / 1000));
    const mins = Math.floor(sec / 60);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);
    if (sec < 60) return "just now";
    if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    if (days === 1) return "yesterday";
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days / 7)} week${days < 14 ? "" : "s"} ago`;
    if (days < 365) return `${Math.floor(days / 30)} month${days < 60 ? "" : "s"} ago`;
    return `${Math.floor(days / 365)} year${days < 730 ? "" : "s"} ago`;
}

export function updatedLabel(t) {
    const rel = relativeTime(t.updated_at);
    if (t.draft) return `Draft · updated ${rel === "just now" ? "today" : rel}`;
    return `Updated ${rel}`;
}
